import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FormEngineModule } from '../form/form-engine.module';
import { AppCoreModule } from '../core/app-core.module';
import { ComponentModule } from '../component/component.module';

import { HomePageComponent } from './home-page/home-page.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { CommercePageComponent } from './commerce-page/commerce-page.component';
import { SalesTpvPageComponent } from './sales-tpv-page/sales-tpv-page.component';
import { CasefileCotejoPageComponent } from './casefile-cotejo-page/casefile-cotejo-page.component';
import { BuroPageComponent } from './buro-page/buro-page.component';
import { AvisoPageComponent } from './aviso-page/aviso-page.component';
import { TerminoPageComponent } from './termino-page/termino-page.component';
import { ConfirmationPageComponent } from './confirmation-Page/confirmation-page.component';
import { privacidadPageComponent } from './privacidad-page/privacidad-page.component';
import { TerminoRegistroPageComponent } from './termino-registro-page/termino-registro-page.component';
import { recoverPageComponent } from './recover-page/recover-page.component';
import { EdicionRegistroComponent } from './edicion-registro/edicion-registro';
import { SatPageComponent } from './sat-page/sat-page.component';


@NgModule({
  imports: [
    CommonModule,
    AppCoreModule,
    FormsModule,
    ReactiveFormsModule,
    FormEngineModule,
  ],
  declarations: [
    HomePageComponent,
    SatPageComponent,
    DashboardPageComponent,
    CommercePageComponent,
    SalesTpvPageComponent,
    CasefileCotejoPageComponent,
    BuroPageComponent,
    AvisoPageComponent,
    TerminoPageComponent,
    TerminoRegistroPageComponent,
    privacidadPageComponent,
    ConfirmationPageComponent,
    recoverPageComponent,
    EdicionRegistroComponent
  ]
})
export class PageModule { }



// WEBPACK FOOTER //
// ./src/app/page/page.module.ts